import React from 'react';
import creation from 'assets/icons/mdi_creation.svg';
import styles from '../chatAssist.module.scss';
const PromptContainer = ({ title, text, image }) => {
  return (
    <div className={styles.tipContainer}>
      <div className={styles.textContainer}>
        <p className={styles.title}>{title}</p>
        <p className={styles.text}>{text}</p>
      </div>
      <img src={!image ? creation : image} alt={title} width={24} height={24} />
    </div>
  );
};

export default PromptContainer;
